import { BANNER_SLIDER_TYPES, BANNER_TYPES } from '@/constants/banner.constants.js';

const MINIMUM_BANNER_COUNT_FOR_AUTOMATIC_SLIDER = 4;

export const setBannerSliderOptions = (
  config,
  sliderOptions,
  banners,
  autoplay,
  bannerType = BANNER_TYPES.MainBanner,
) => {
  const sliderType = config?.bannerSliderType?.type;

  if (sliderType === BANNER_SLIDER_TYPES.Static) {
    sliderOptions.autoplay = false;
    sliderOptions.loop = false;
    sliderOptions.resistance = true;
    sliderOptions.resistanceRatio = 0;
    sliderOptions.allowTouchMove = false;

    const slidesPerView = Number(sliderOptions.slidesPerView) || 1;
    const visibleBannerCount = Math.min(slidesPerView, banners.length);

    banners = banners.slice(0, visibleBannerCount);
    autoplay = config?.autoplay;
  } else if (sliderType === BANNER_SLIDER_TYPES.Automatic) {
    if (bannerType === BANNER_TYPES.MultiBanner) {
      if (banners.length > MINIMUM_BANNER_COUNT_FOR_AUTOMATIC_SLIDER) {
        sliderOptions.autoplay = {
          delay: config.period * 1000,
          disableOnInteraction: false,
        };
      } else {
        sliderOptions.autoplay = false;
        sliderOptions.loop = false;
        sliderOptions.resistance = true;
        sliderOptions.resistanceRatio = 0;
      }
    } else if (bannerType === BANNER_TYPES.MainBanner) {
      sliderOptions.autoplay = {
        delay: config.period * 1000,
        disableOnInteraction: false,
      };
    }
  } else if (sliderType === BANNER_SLIDER_TYPES.Manual) {
    sliderOptions.autoplay = false;
    autoplay = config?.autoplay;
  }
  return { sliderOptions, banners, autoplay };
};
